import { LoaderCircle } from 'lucide-react';

import cls from './PageLoader.module.scss';

export const PageLoader = () => {
  return (
    <div
      data-testid={'page-loader'}
      className={cls.wrap}
    >
      <LoaderCircle
        className={cls.spinner}
        size={52}
      />
    </div>
  );
};
